// Purpose: admin user management — list, role change, (de)activate.

import { api, csrfHeaders } from './client.ts';

export type Role = 'USER' | 'ADMIN' | 'READONLY';

export interface AdminUserSummary {
  id: string;
  email: string;
  displayName: string;
  role: Role;
  active: boolean;
  createdAt: string;
  lastLoginAt: string | null;
  activeShareCount: number;
  activeDropboxCount: number;
}

export async function listUsers(): Promise<AdminUserSummary[]> {
  const res = await api.get<{ users: AdminUserSummary[] }>('/admin/users');
  return res.data.users;
}

export async function getUser(id: string): Promise<AdminUserSummary> {
  const res = await api.get<AdminUserSummary>(`/admin/users/${id}`);
  return res.data;
}

export async function changeUserRole(id: string, role: Role): Promise<void> {
  await api.post(`/admin/users/${id}/role`, { role }, { headers: csrfHeaders() });
}

export async function deactivateUser(id: string, reason: string): Promise<void> {
  await api.post(`/admin/users/${id}/deactivate`, { reason }, { headers: csrfHeaders() });
}

export async function reactivateUser(id: string): Promise<void> {
  await api.post(`/admin/users/${id}/reactivate`, null, { headers: csrfHeaders() });
}
